// NOTE: uses commentsColorMap var saved to store from the Study component
import React, { useState } from "react"
import { useShallow } from "zustand/react/shallow"
import dayjs from "dayjs"
import parse from "html-react-parser"

// components
import { Dropdown } from "antd"
import { Badge } from "components-design-system"

// api
import { useUserPermissions } from "api/hooks"

// store
import useAuthoringCommentsStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringCommentsStore"
import useAuthoringCommentActions from "containers/studies/Study/subcomponents/Authoring/hooks/actions/useAuthoringCommentActions"

// styles
import "./RJCommentItem.scss"

const RJCommentItem = ({ comment, index, handleEdit, handleDelete, showMenu = true }) => {
  const { data: permissions } = useUserPermissions()
  const [openMenu, setOpenMenu] = useState(false)
  const [isFavorite, setIsFavorite] = React.useState(comment.favorite)
  const [isResolved, setIsResolved] = React.useState(comment.resolved)
  const { handleFavorite, handleResolved } = useAuthoringCommentActions()

  const { commentsColorMap } = useAuthoringCommentsStore(
    useShallow((state) => ({
      commentsColorMap: state.commentsColorMap,
    }))
  )

  const displayTags = (tags) => {
    return tags.map((tag) => (
      <Badge
        key={comment.id + tag}
        value={tag}
        colorName={commentsColorMap?.[tag]}
      />
    ))
  }

  if (!comment) return <></>

  let initials = ""
  if (comment?.author_fullname) {
    let names = comment.author_fullname.split(" ")
    if (names[0] && names[0].length > 0) initials += names[0][0]
    if (names[1] && names[1].length > 0) initials += names[1][0]
    initials.toUpperCase()
  }

  const items = []
  items.push({
    key: "edit",
    label: "Edit",
    disabled: !permissions["study.authoringcomment.edit"] && comment.author_id !== permissions.user_id,
  })

  items.push({
    key: "delete",
    label: "Delete",
    disabled: !permissions["study.authoringcomment.delete"] && comment.author_id !== permissions.user_id,
  })

  const onClick = (e) => {
    if (e.key === "edit") {
      handleEdit(comment)
      setOpenMenu(false)
    } else if (e.key === "delete") {
      handleDelete(comment)
    }
  }

  const onResolveSuccess = () => {
    setIsResolved(!isResolved)
  }

  const onFavoriteSuccess = () => {
    setIsFavorite(!isFavorite)
  }

  return (
    <div
      id={"rj-comment-item-container" + index}
      className="rj-comment-item"
    >
      <div className="comment-initial">{initials}</div>
      <div className="rj-comment-header">
        <div className="rj-comment-author-wrap">
          {comment.author_fullname && comment.author_fullname}
          <div className="tags-wrap">{displayTags(comment.tags)}</div>
        </div>
        <div className="rj-comment-action-wrap">
          <i
            className={`fal fa-heart favorite-icon${isFavorite ? " favorite" : ""}`}
            onClick={() => handleFavorite(comment, onFavoriteSuccess)}
          />
          <i
            className={`fal fa-check-circle resolved-icon${isResolved ? " resolved" : ""}`}
            onClick={() => handleResolved(comment, onResolveSuccess)}
          />
          {permissions && showMenu !== false && (
            <Dropdown
              menu={{
                items,
                onClick,
              }}
              getPopupContainer={() => document.getElementById("rj-comment-item-container" + index)}
              placement="bottomLeft"
              destroyPopupOnHide={true}
            >
              <i
                onClick={() => setOpenMenu(!openMenu)}
                className="fal fa-ellipsis-h rj-item-menu-icon"
              ></i>
            </Dropdown>
          )}
        </div>
      </div>
      <div className="rj-comment-subheader">{comment.date && dayjs(comment.date).format("YYYY-MM-DD HH:mm:ss")}</div>
      <div className="rj-comment-item-item">{comment.text && parse(comment.text)}</div>
    </div>
  )
}

export default RJCommentItem
